import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type FiltersForm from 'modules/core/lib/forms/Filters'

interface SortableHeaderProps {
  attribute: string
  filtersForm: FiltersForm
  children?: React.ReactNode
  left?: React.ReactNode
  width?: number
}

const SortableHeader = observer(
  ({ left, attribute, filtersForm, width, children }: SortableHeaderProps) => {
    const sortDirection = filtersForm.get('sortDirection')
    const sortAttribute = filtersForm.get('sortAttribute')

    return (
      <Table.SortableHeadCell
        left={left}
        onSort={(attr, direction) => {
          sortDirection.set(direction)
          sortAttribute.set(attr)
        }}
        attribute={attribute}
        sortAttribute={sortAttribute.value}
        sortDirection={sortDirection.value}
        width={width}
      >
        {children}
      </Table.SortableHeadCell>
    )
  }
)

export default SortableHeader
